export var ENTITY = "external-action";
export var REDUCER_KEY = "EXTERNAL_ACTION";
export var BASE_PATH_ENTITY = "external-action";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    legacyGetDetail: true,
};
